import Vue from 'vue'
//https://www.cnblogs.com/shiblog/p/12119672.html
const preventReClick = Vue.directive('preventReClick', {
    inserted: function (el, binding) {
        el.addEventListener('click', () => {
            if (!el.disabled) {
                el.disabled = true
                setTimeout(() => {
                    el.disabled = false
                }, binding.value || 3000)
            }
        })
    }
});

export { preventReClick }



// WEBPACK FOOTER //
// ./src/common/preventReClick.js